// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { ParticipantDto } from '../_module/dto/participant.dto';
import { wsc } from '../wsc';
import { Observable } from 'rxjs';
import { FetchScoreRankingResponseRowDto } from './dto/fetch-score-ranking-response-row.dto';

export class ScoreModel {
  static listenAnswer(): Observable<{
    participant: ParticipantDto;
    selected: number[];
  }> {
    return wsc.subscribe('/ws/score/listenAnswer') as any;
  }

  static fetchAllAnswers(): Promise<
    { participant: ParticipantDto; selected: number[] }[]
  > {
    return wsc.execute('/ws/score/fetchAllAnswers') as any;
  }

  static fetchCorrectlyCount(): Promise<any> {
    return wsc.execute('/ws/score/fetchCorrectlyCount') as any;
  }

  static fetchCorrectlyParticipants(): Promise<ParticipantDto[]> {
    return wsc.execute('/ws/score/fetchCorrectlyParticipants') as any;
  }

  static fetchTopTenParticipants(): Promise<FetchScoreRankingResponseRowDto[]> {
    return wsc.execute('/ws/score/fetchTopTenParticipants') as any;
  }

  static answer(selected: number[]): Promise<any> {
    return wsc.execute('/ws/score/answer', selected) as any;
  }

  static fetchAnswered(): Promise<number[] | null> {
    return wsc.execute('/ws/score/fetchAnswered') as any;
  }

  static isCorrectly(): Promise<boolean> {
    return wsc.execute('/ws/score/isCorrectly') as any;
  }

  static fetchIsFilmstripExecuted(): Promise<boolean> {
    return wsc.execute('/ws/score/fetchIsFilmstripExecuted') as any;
  }

  static fetchResult(): Promise<{
    isCorrectly: boolean;
    score: number;
    rank: number;
  }> {
    return wsc.execute('/ws/score/fetchResult') as any;
  }
}
// c0a589cb2955a40b825941c8f33555c04b99a7d2cfc186fc9d829e7810954050
